import CreatePhraseBookController from './controller/CreatePhraseBookController'
const template = require('./createPhraseBook.tpl.pug')

const createPhraseBook = {
  parent: angular.element(document.body),
  template: template(),
  clickOutsideToClose: false,
  fullscreen: false,
  bindToController: true,
  controllerAs: '$ctrl',
  controller: CreatePhraseBookController
}

export default createPhraseBook

